export default __webpack_public_path__ + "static/media/trainX.103f06af.jpeg";